/**
 * The key the engine's candidate generator de-duplicates deposit levels on (owner-caught, 9 Oct 2026).
 *
 * Two levels that would PAY the same deposit are one candidate: a client with $455,000 fundable
 * against a $700,000 room funds $455,000 at "65%" and at every level above it, and eight copies of
 * one plan under different names is what the key prevents. It used to be the amount SOLD from
 * savings. A village's exit payment (or a current room's refund) tops a level up without selling
 * anything, so for a resident whose $750,000 payout covered a $750,000 room, every level sold $0,
 * every level keyed the same, and only "Pay 10% RAD" survived: the 100% row, the best estate by far,
 * was never run. The key is now the deposit the level actually pays.
 */
export function radLevelDedupeKey(input: { orderLabel: string; level: number; fundedTotal: number; topUp: number }): string {
    const level = Math.max(0, Number(input.level) || 0);
    const funded = Math.max(0, Number(input.fundedTotal) || 0);
    const topUp = Math.max(0, Number(input.topUp) || 0);
    const paid = Math.min(level, funded + topUp);
    return `${input.orderLabel}:${Math.round(paid)}`;
}
